import React from "react";
import { Link } from "react-router-dom";
import ErrorTemplate from "../templates/ErrorTemplate.jsx";

function NotFoundContent() {
  const icon = (
    <svg
      className="mx-auto h-24 w-24 text-gray-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.562M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );

  const actions = [
    <Link
      key="home"
      to="/"
      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-500 hover:bg-orange-600"
    >
      Go Home
    </Link>,
    <button
      key="back"
      onClick={() => window.history.back()}
      className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
    >
      Go Back
    </button>,
  ];

  return (
    <ErrorTemplate
      icon={icon}
      title="Page Not Found"
      description="The page you're looking for doesn't exist or has been moved."
      actions={actions}
    />
  );
}

export default NotFoundContent;
